import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import PrimaryButton from '../../common/components/PrimaryButton';
import Config from '../../api/config';

export default function MarketplaceSubscriptionsEmptyState() {
    return (
        <Box className="outer-container with-nav">
            <Container maxWidth="md">
                <Box
                    data-testid="marketplace-subscriptions-empty-state"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    py={8}
                >
                    <Typography variant="subtitle2" color="secondaryTint.blue" textTransform="uppercase" marginBottom={1}>
                        Train With The Best
                    </Typography>
                    <Typography variant="h3" align="center" marginBottom={1}>
                        JOIN A TEAM
                    </Typography>
                    <Typography variant="subtitle1" align="center" color="text.secondary">
                        Find expert-coached teams that match your training goals{'\n'}and take your performance to the next level.
                    </Typography>
                    <Box marginTop={4}>
                        <PrimaryButton onClick={() => { window.location.href = Config.URL_MARKETPLACE; }}>
                            Browse Marketplace
                        </PrimaryButton>
                    </Box>
                </Box>
        </Container>
        </Box>
    );
}
